import * as Api from '@ViewModels';

/** The API's message for a client error (4xx), which is written for the user; anything else gets the fallback. */
export const userFacingErrorMessage = (error: unknown, fallback: string) => {
	const { systemCode, systemMessage } = (error ?? {}) as Api.IOperationResultNoValue;
	return systemMessage && systemCode >= 400 && systemCode < 500 ? systemMessage : fallback;
};
